module.exports = __webpack_public_path__ + "img/blue_114.ef8659bb.png";